

<template>
  <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
    <v-layout justify-center align-center>
      <v-flex shrink align-center justify-center>
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title :style="$store.state.textFormatting.headers">
            Live alerting settings
          </v-toolbar-title>
          <v-spacer />
          <info>
              <template slot>
                  <h3> Live Alerting </h3>
              </template>
              <template slot="body">
                  <p> 
                    Press the button to start 'live' alerting.
                  </p>
                  <p> Choose a polling interval to pull the alerts less/ more frequently, and flick the toggle to limit the screen to only the organisation pane. </p>
              </template>
          </info>
        </v-toolbar>
        <v-card>
          <v-layout>
            <v-flex shrink class="px-1 py-1">
              <v-btn @click="flipPoll" :color="poll_color" :style="$store.state.textFormatting.main">{{poll_msg}}</v-btn>
            </v-flex>
            <v-flex xs5 fluid class="px-1 py-1">
              <v-text-field
                v-model="polling_interval"
                @change="changePollingInterval"
                label="Polling interval (s)"
                :rules="polling_interval_rules"
                :style="$store.state.textFormatting.main"
              />
            </v-flex>
            <v-flex class="px-1 py-1">
              <v-tooltip top eager close-delay=500 >
                  <template  v-slot:activator="{ on }">
                      <v-switch slot="activator" v-on="on" v-model="org_only">
                          <template v-slot:label>
                              <div :style="$store.state.textFormatting.main">Organisation only?</div>
                          </template>
                      </v-switch>
                  </template>
                  <span :style="$store.state.textFormatting.main">This will hide the 'User' side of the page completely</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex class="px-3 py-2 text-xs-center" shrink>
              <h3 v-if="updatedStr.length > 1"> {{ updatedStr }} </h3>
            </v-flex>
            <v-flex xs2 class="px-3 py-2 text-xs-center" shrink>
              <v-card :color="countdownColor">
                <h4> {{ countDown }}s </h4>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>



    <v-layout justify-center align-center>
      <v-flex xs12 :xl6="!org_only" class="px-2 py-2">
        <v-card
          :color="alertsbannercolor_org"
          v-if="org_bonus_asns_arr.length > 0 || org_bonus_prefixes_arr.length > 0"
        >
          <v-layout v-if="org_alerts_flip">
            <v-flex xs10 class="px-1 py-1">
              <h1 :style="$store.state.textFormatting.headers"> {{ org_bonus_alerts.length }} new alerts. Click to expand </h1>
            </v-flex>
            <v-spacer />
            <v-flex xs1>
              <v-btn
                color="accent"
                small
                fab
                dark
                class="mx-2"
                @click="org_alerts_flip=!org_alerts_flip"
                :style="$store.state.textFormatting.main"
              >+</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="!org_alerts_flip">
            <v-flex xs7 class="px-1 py-1">
              <v-flex class="px-2 py-2" v-if="org_bonus_asns_arr.length > 0">
                <h1 :style="$store.state.textFormatting.headers">ASN Summary</h1>
              </v-flex>
              <v-flex class="px-2 py-2" v-for="asn in org_bonus_asns_arr" :key="asn.index">
                <v-card :color="asn.color">
                  <v-layout>
                    <v-flex xs11 class="px-1 py-1">
                      <h2 :style="$store.state.textFormatting.main">&nbsp; {{ asn.asn }}</h2>
                      <h3 :style="$store.state.textFormatting.main">&nbsp; {{ asn.summary }}</h3>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex class="px-2 py-2" v-if="org_bonus_prefixes_arr.length > 0">
                <h1 :style="$store.state.textFormatting.headers">Restricted Prefix Summary</h1>
              </v-flex>
              <v-flex class="px-2 py-2" v-for="pre in org_bonus_prefixes_arr" :key="pre.index">
                <v-card :color="pre.color">
                  <v-layout>
                    <v-flex xs11 class="px-1 py-1">
                      <h2 :style="$store.state.textFormatting.main">&nbsp; {{ pre.prefix }}</h2>
                      <h3 :style="$store.state.textFormatting.main">&nbsp; {{ pre.summary }}</h3>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-layout>
                <v-spacer />
                <v-flex xs2>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="org_alerts_flip=!org_alerts_flip"
                    :style="$store.state.textFormatting.main"
                  >-</v-btn>
                </v-flex>
              </v-layout>
              <v-layout align-right justify-center>
                <v-flex xs8 class="text-xs-right; py-3" justify-center>
                  <h3 :style="$store.state.textFormatting.main" class="text-xs-right">Click here to pull alerts into main stack -></h3>
                </v-flex>
                <v-flex xs4 class="py-2">
                  <v-btn :style="$store.state.textFormatting.main" color="accent" rounded small dark @click="mergeAlerts('org')">merge</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs8 class="text-xs-right; py-3">
                  <h3 :style="$store.state.textFormatting.main" class="text-xs-right">Click here to show only new alerts -></h3>
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="showNewAlerts('neworg')"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>



      <v-flex xs12 xl6 class="px-2 py-2" v-if="!org_only">
        <v-card
          :color="alertsbannercolor_user"
          v-if="user_bonus_asns_arr.length > 0 || user_bonus_prefixes_arr.length > 0"
        >
          <v-layout v-if="user_alerts_flip">
            <v-flex xs10 class="px-1 py-1">
              <h1 :style="$store.state.textFormatting.headers"> {{ user_bonus_alerts.length }} new alerts. Click to expand </h1>
            </v-flex>
            <v-spacer />
            <v-flex xs1>
              <v-btn
                color="accent"
                small
                fab
                dark
                class="mx-2"
                @click="user_alerts_flip=!user_alerts_flip"
                :style="$store.state.textFormatting.main"
              >+</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="!user_alerts_flip">
            <v-flex xs7 class="px-1 py-1">
              <v-flex class="px-2 py-2" v-if="user_bonus_asns_arr.length > 0">
                <h1 :style="$store.state.textFormatting.headers">ASN Summary</h1>
              </v-flex>
              <v-flex class="px-2 py-2" v-for="asn in user_bonus_asns_arr" :key="asn.index">
                <v-card :color="asn.color">
                  <v-layout>
                    <v-flex xs11 class="px-1 py-1">
                      <h2 :style="$store.state.textFormatting.main">&nbsp; {{ asn.asn }}</h2>
                      <h3 :style="$store.state.textFormatting.main">&nbsp; {{ asn.summary }}</h3>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex class="px-2 py-2" v-if="user_bonus_prefixes_arr.length > 0">
                <h1 :style="$store.state.textFormatting.headers">Restricted Prefix Summary</h1>
              </v-flex>
              <v-flex class="px-2 py-2" v-for="pre in user_bonus_prefixes_arr" :key="pre.index">
                <v-card :color="pre.color">
                  <v-layout>
                    <v-flex xs11 class="px-1 py-1">
                      <h2 :style="$store.state.textFormatting.main">&nbsp; {{ pre.prefix }}</h2>
                      <h3 :style="$store.state.textFormatting.main">&nbsp; {{ pre.summary }}</h3>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-flex>
            <v-flex xs5>
              <v-layout>
                <v-spacer />
                <v-flex xs2>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="user_alerts_flip=!user_alerts_flip"
                    :style="$store.state.textFormatting.main"
                  >-</v-btn>
                </v-flex>
              </v-layout>
              <v-layout align-right justify-center>
                <v-flex xs8 class="text-xs-right; py-3" justify-center>
                  <h3 :style="$store.state.textFormatting.main" class="text-xs-right">Click here to pull alerts into main stack -></h3>
                </v-flex>
                <v-flex xs4 class="py-2">
                  <v-btn :style="$store.state.textFormatting.main" color="accent" rounded small dark @click="mergeAlerts('user')">merge</v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs8 class="text-xs-right; py-3">
                  <h3 :style="$store.state.textFormatting.main" class="text-xs-right">Click here to show only new alerts -></h3>
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="showNewAlerts('newuser')"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>



    <v-layout justify-start align-start wrap>
      <v-flex xs12 :xl6="!org_only" class="px-2 py-2">
        <!-- Summary table -->
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title :style="$store.state.textFormatting.headers">Organisation ASN &amp; Prefix Summary</v-toolbar-title>
          <v-spacer />
          <v-btn @click="useBubbleData('org')" rounded small dark color="success" :style="$store.state.textFormatting.main" :disabled="bubble_type=='org'&&showbubble==true"> bubble </v-btn>
          <info>
            <template slot>
                Executive Summary
            </template>
            <template slot="body">
                <p> Here, a summary of alerts in your organisation/ user profile will appear. </p>
                <p> Initially, this will be populated with the last <b>week's worth</b> of alerts. </p>
                <p> Press the <v-btn color="accent" small fab dark class="mx-2">+</v-btn> to expand these alerts, filter and interrogate them (and mark them as 'Reviewed'). </p>
                <p> You can enable a live feed of alerts coming through, and select a polling interval. These new alerts will appear in a banner above the two windows, which can be expanded, interrogated, then merged into the main alerts. </p>
                <p> Press the <v-btn rounded small dark color="success" :style="$store.state.textFormatting.main"> bubble </v-btn> button to show a bubble graph of the alerts over time </p>

            </template>
          </info>
        </v-toolbar>
        <v-card v-if="!load_org">
          <v-flex class="px-2 py-2">
            <h1 :style="$store.state.textFormatting.headers">ASN Summary</h1>
          </v-flex>
          <v-flex class="px-2 py-2" v-for="asn in org_asns_arr" :key="asn.index">
            <v-card :color="asn.color">
              <v-layout>
                <v-flex xs11 class="px-1 py-1">
                  <h2 :style="$store.state.textFormatting.main">&nbsp; {{ asn.asn }}</h2>
                  <h3 :style="$store.state.textFormatting.main">&nbsp; {{ asn.summary }}</h3>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="filterAlerts('org', '', asn.asn)"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex class="px-2 py-2">
            <h1 :style="$store.state.textFormatting.headers">Restricted Prefix Summary <v-btn color="accent" rounded small dark @click="org_show_names=!org_show_names">names/ prefixes</v-btn> </h1>
          </v-flex>
          <v-flex class="px-2 py-2" v-for="pre in org_prefixes_arr" :key="pre.index">
            <v-card :color="pre.color">
              <v-layout>
                <v-flex xs11 class="px-1 py-1">
                  <h2 :style="$store.state.textFormatting.main" v-if="!org_show_names">&nbsp; {{ pre.prefix }}</h2>
                  <h2 :style="$store.state.textFormatting.main" v-if="org_show_names">&nbsp; {{ org_prefix_names[pre.prefix] }}</h2>
                  <h3 :style="$store.state.textFormatting.main">&nbsp; {{ pre.summary }}</h3>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="filterAlerts('org', pre.prefix, '')"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
        <v-card v-if="load_org">
          <v-flex>
            <v-progress-circular color="secondary" indeterminate />
          </v-flex>
        </v-card>
      </v-flex>



      <v-flex xs12 xl6 class="px-2 py-2" v-if="!org_only">
        <!-- Summary table -->
        <v-toolbar color="accent" dark flat>
          <v-toolbar-title :style="$store.state.textFormatting.headers">User ASN &amp; Prefix Summary</v-toolbar-title>
          <v-spacer />
          <v-btn @click="useBubbleData('user')" rounded small dark color="success" :style="$store.state.textFormatting.main" :disabled="bubble_type=='user'&&showbubble==true"> bubble </v-btn>
        </v-toolbar>
        <v-card v-if="!load_user">
          <v-flex class="px-2 py-2">
            <h1 :style="$store.state.textFormatting.headers">ASN Summary</h1>
          </v-flex>
          <v-flex class="px-2 py-2" v-for="asn in user_asns_arr" :key="asn.index">
            <v-card :color="asn.color">
              <v-layout>
                <v-flex xs11 class="px-1 py-1">
                  <h2 :style="$store.state.textFormatting.main">&nbsp; {{ asn.asn }}</h2>
                  <h3 :style="$store.state.textFormatting.main">&nbsp; {{ asn.summary }}</h3>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="filterAlerts('user', '', asn.asn)"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex class="px-2 py-2">
            <h1 :style="$store.state.textFormatting.headers">Restricted Prefix Summary <v-btn color="accent" rounded small dark @click="user_show_names=!user_show_names">names/ prefixes</v-btn> </h1>
          </v-flex>
          <v-flex class="px-2 py-2" v-for="pre in user_prefixes_arr" :key="pre.index">
            <v-card :color="pre.color">
              <v-layout>
                <v-flex xs11 class="px-1 py-1">
                  <h2 v-if="!user_show_names" :style="$store.state.textFormatting.main">&nbsp; {{ pre.prefix }}</h2>
                  <h2 v-if="user_show_names" :style="$store.state.textFormatting.main">&nbsp; {{ user_prefix_names[pre.prefix] }}</h2>
                  <h3 :style="$store.state.textFormatting.main">&nbsp; {{ pre.summary }}</h3>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    color="accent"
                    small
                    fab
                    dark
                    class="mx-2"
                    @click="filterAlerts('user', pre.prefix, '')"
                    :style="$store.state.textFormatting.main"
                  >+</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
        <v-card v-if="load_user">
          <v-flex>
            <v-progress-circular color="secondary" indeterminate />
          </v-flex>
        </v-card>
      </v-flex>



      <v-flex class="px-2 py-2">
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title :style="$store.state.textFormatting.headers">
            Filtered Results
          </v-toolbar-title>
          <v-spacer />
          <v-btn v-if="showalerts" color="red" small fab dark class="mx-2" @click="showalerts=false" :style="$store.state.textFormatting.main">x</v-btn>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex v-if="!showalerts">
                <h2> Select one of the <v-btn color="accent" small fab dark class="mx-2" :style="$store.state.textFormatting.main">+</v-btn> buttons to view alerts </h2>
              </v-flex>
            </v-layout>

            <v-flex class="px-4 py-2 text-xs-center" justify-center align-center> 
                  <v-layout v-if="showalerts" align-center justify-center>
                    <v-flex class="text-xs-center px-4" shrink>
                      <v-tooltip top eager close-delay="500">
                        <template v-slot:activator="{ on }">
                          <v-switch
                            slot="activator"
                            v-on="on"
                            v-model="exclude_path_change"
                            @change="excludeChange()"
                            :style="$store.state.textFormatting.main"
                          >
                            <template v-slot:label>
                              <div :style="$store.state.textFormatting.main">Include path change alerts</div>
                            </template>
                          </v-switch>
                        </template>
                        <span
                          :style="$store.state.textFormatting.main"
                        >Alerts where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex class="text-xs-center px-4" shrink>
                      <v-tooltip top eager close-delay="500">
                        <template v-slot:activator="{ on }">
                          <v-switch
                            slot="activator"
                            v-on="on"
                            v-model="exclude_first_seen"
                            @change="excludeChange()"
                            :style="$store.state.textFormatting.main"
                          >
                            <template v-slot:label>
                              <div
                                :style="$store.state.textFormatting.main"
                              >Include first seen prefix alerts</div>
                            </template>
                          </v-switch>
                        </template>
                        <span
                          :style="$store.state.textFormatting.main"
                        >Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="filter_criteria.prefix.length < 6" class="text-xs-center px-4" shrink>
                      <v-tooltip top eager close-delay="500">
                        <template v-slot:activator="{ on }">
                          <v-switch
                            slot="activator"
                            v-on="on"
                            v-model="exclude_in_path"
                            @change="excludeChange()"
                            :style="$store.state.textFormatting.main"
                          >
                            <template v-slot:label>
                              <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                            </template>
                          </v-switch>
                        </template>
                        <span
                          :style="$store.state.textFormatting.main"
                        >Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new)</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex class="text-xs-center px-4" shrink>
                      <v-tooltip top eager close-delay="500">
                        <template v-slot:activator="{ on }">
                          <v-switch
                            slot="activator"
                            v-on="on"
                            v-model="exclude_own_assert"
                            @change="excludeChange()"
                            :style="$store.state.textFormatting.main"
                          >
                            <template v-slot:label>
                              <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                            </template>
                          </v-switch>
                        </template>
                        <span
                          :style="$store.state.textFormatting.main"
                        >Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex class="py-2 px-4 text-xs-center" v-if="allow_dealt" xs4 align-center justify-center>
                      <v-tooltip top eager close-delay=500 >
                          <template  v-slot:activator="{ on }">
                              <v-btn @click="updateDealtWithMany(1)" color="success" v-on="on" :style="$store.state.textFormatting.main"> Update reviewed </v-btn>        
                          </template>
                          <span :style="$store.state.textFormatting.main">Click here to remove the ticked alerts from your organisation's alerts</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
            </v-flex>

            <v-flex v-if="showalerts">
              <v-data-table
                :headers="headers"
                :items="filtered_alerts"
                :key="id"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
              >
                <template slot="headerCell" slot-scope="props">
                    <v-tooltip top eager>
                    <span slot="activator" :style="$store.state.textFormatting.main">
                        <div v-for="line in props.header.text" :key="line.index">
                            <div> {{ line }} </div>
                        </div>
                    </span>
                    <span :style="$store.state.textFormatting.main">
                        {{ props.header.ad_text }}
                    </span>
                    </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-center" :style="$store.state.textFormatting.main">
                      <v-checkbox
                        class="text-xs-center"
                        hide-details
                        v-if="!props.item.dealt_with_t"
                        v-model="props.item.dealt_with_t"
                        @change="tagDealtWith(props.item, 1)"
                      />
                      <v-checkbox
                        class="text-xs-center"
                        hide-details
                        v-if="props.item.dealt_with_t"
                        v-model="props.item.dealt_with_t"
                        @change="tagDealtWith(props.item, 0)"
                      />
                    </td>

                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.alert_type }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.prefix }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.non_direct_prefix }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.origin_asn_old }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.origin_asn_new }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.asn_of_interest }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.hijack_score_mean }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.impact_score_mean }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >
                      <v-chip
                        :color="getColor(props.item.interval_start.date)"
                        text-color="#000000"
                        dark
                        :style="$store.state.textFormatting.main"
                      >{{ props.item.interval_start.date }}</v-chip>
                    </td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.interval_start.time }}</td>
                  </tr>
                </template>
                <template slot="no-data">
                  <v-alert
                    :value="true"
                    color="success"
                    icon="warning"
                    :style="$store.state.textFormatting.main"
                  >No alerts - consider changing sliders above</v-alert>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>


    <v-layout>
      <v-flex class="px-2 py-2">
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title :style="$store.state.textFormatting.headers">
            Alerts Over Time 
            <span v-if="showbubble&&bubble_type=='user'"> - {{ user }} </span>
            <span v-if="showbubble&&bubble_type=='org'"> - {{ organisation }} </span>
          </v-toolbar-title>
          <v-spacer />
          <info>
            <template slot>
                Alerts over time bubble graph
            </template>
            <template slot="body">
                <p> Displays selected alerts, colour coded by prefix/ ASN of interest to your organisation/ user. </p>
                <p> The 'Y' axis is the hijack score of the alert, with the size representing the event count in the selected alert (i.e. how many events have occured with the same base attributes in that 5 minute period). </p>
                <p> Click on a bubble to bring up the alert in a table below. </p>
                <p> This can then be clicked to bring up the alert details page. </p>
            </template>
          </info>
        </v-toolbar>
        <v-card v-if="showbubble">
        <v-layout>
              <v-flex class="px-4 py-2 text-xs-center" justify-center align-center> 
                    <v-layout align-center justify-center>
                      <v-flex class="text-xs-center px-4" shrink>
                        <v-tooltip top eager close-delay="500">
                          <template v-slot:activator="{ on }">
                            <v-switch
                              slot="activator"
                              v-on="on"
                              v-model="exclude_path_change"
                              @change="bubbleExclude()"
                              :style="$store.state.textFormatting.main"
                            >
                              <template v-slot:label>
                                <div :style="$store.state.textFormatting.main">Include path change alerts</div>
                              </template>
                            </v-switch>
                          </template>
                          <span
                            :style="$store.state.textFormatting.main"
                          >Alerts where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="text-xs-center px-4" shrink>
                        <v-tooltip top eager close-delay="500">
                          <template v-slot:activator="{ on }">
                            <v-switch
                              slot="activator"
                              v-on="on"
                              v-model="exclude_first_seen"
                              @change="bubbleExclude()"
                              :style="$store.state.textFormatting.main"
                            >
                              <template v-slot:label>
                                <div
                                  :style="$store.state.textFormatting.main"
                                >Include first seen prefix alerts</div>
                              </template>
                            </v-switch>
                          </template>
                          <span
                            :style="$store.state.textFormatting.main"
                          >Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="text-xs-center px-4" shrink>
                        <v-tooltip top eager close-delay="500">
                          <template v-slot:activator="{ on }">
                            <v-switch
                              slot="activator"
                              v-on="on"
                              v-model="exclude_in_path"
                              @change="bubbleExclude()"
                              :style="$store.state.textFormatting.main"
                            >
                              <template v-slot:label>
                                <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                              </template>
                            </v-switch>
                          </template>
                          <span
                            :style="$store.state.textFormatting.main"
                          >Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new)</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="text-xs-center px-4" shrink>
                        <v-tooltip top eager close-delay="500">
                          <template v-slot:activator="{ on }">
                            <v-switch
                              slot="activator"
                              v-on="on"
                              v-model="exclude_own_assert"
                              @change="bubbleExclude()"
                              :style="$store.state.textFormatting.main"
                            >
                              <template v-slot:label>
                                <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                              </template>
                            </v-switch>
                          </template>
                          <span
                            :style="$store.state.textFormatting.main"
                          >Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
              </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex class="px-8 py-2 text-xs-center">
              <bubbleGraph style="height:50vh; width:90vw" :chart-data="bubbleData"  :options="options" :key="id"> </bubbleGraph>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card v-if="!showbubble">
          <v-card-text>
            <v-layout>
              <v-flex>
                <h2> Select one of the <v-btn color="success" small rounded dark class="mx-2" :style="$store.state.textFormatting.main">bubble</v-btn> buttons to view alerts </h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card v-if="bubble_alert">
          <v-card-text>
            <v-flex>
              <v-data-table
                :headers="bubbleHeaders"
                :items="bubble_alert"
                :key="id"
                :rows-per-page-items="rowsPerPageItems2"
                :pagination.sync="pagination2"
              >
                <template slot="headerCell" slot-scope="props">
                    <v-tooltip top eager>
                    <span slot="activator" :style="$store.state.textFormatting.main">
                        <div v-for="line in props.header.text" :key="line.index">
                            <div> {{ line }} </div>
                        </div>
                    </span>
                    <span :style="$store.state.textFormatting.main">
                        {{ props.header.ad_text }}
                    </span>
                    </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>

                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.alert_type }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.prefix }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.non_direct_prefix }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.origin_asn_old }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.origin_asn_new }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.asn_of_interest }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.hijack_score_mean }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.impact_score_mean }}</td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >
                      <v-chip
                        :color="getColor(props.item.interval_start.date)"
                        text-color="#000000"
                        dark
                        :style="$store.state.textFormatting.main"
                      >{{ props.item.interval_start.date }}</v-chip>
                    </td>
                    <td
                      @click="clickHandleAlert(props.item)"
                      class="text-xs-center"
                      :style="$store.state.textFormatting.main"
                    >{{ props.item.interval_start.time }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import info from "../../shared/operational/infopopout.vue";
import { mdiArrowRight, mdiMerge, mdiCallMerge } from "@mdi/js";
import downloadcsv from "vue-json-csv";
import { findParentComponentByName } from "../utils/findParent.js";
import bubbleGraph from '../../shared/developing/bubble-graph.js'

export default {
  name: "execsummary",
  components: {
    info,
    downloadcsv,
    bubbleGraph
  },
  icons: {
    iconfont: "mdi"
  },
  data() {
    return {
      allRound: 0,
      showTheBox: true,
      allUserAlerts: [],
      allLoading: false,
      allErrMsg: false,
      showAllDownload: false,
      exclude_first_seen: false, //these behave functionally back to front
      exclude_path_change: false, //these behave functionally back to front
      exclude_in_path: false, //these behave functionally back to front
      exclude_own_assert: false, //these behave functionally back to front
      userSpecificOrderBy: null,
      prefix: null,
      orderBy: "hijack_score_mean",
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        descending: null
      },
      rowsPerPageItems: [10, 20, 30, 40, 50, 100],
      pagination2: {
        rowsPerPage: 10,
        sortBy: null,
        descending: null
      },
      rowsPerPageItems2: [10, 20, 30, 40, 50, 100],
      headers: [
          { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
          { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
          { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
          { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
          { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
          { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
          { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
          { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
          { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
          { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
          { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
      ],
      bubbleHeaders: [
          //{ text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
          { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
          { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
          { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
          { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
          { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
          { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
          { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
          { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
          { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
          { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
      ],
      userorg: "Org1",
      data: [],
      current10Data: [],
      id: null,
      alertperasn: [],
      isdata: true,
      updatedStr: "",
      loading: false,
      expand: false,
      ddinfo: {},
      orderByList: [
        { name: "New ASN", param: "origin_asn_new" },
        { name: "Old ASN", param: "origin_asn_old" },
        { name: "Time", param: "time_5min" },
        { name: "Hijack Score", param: "hijack_score_mean" },
        { name: "Impact Score", param: "impact_score_mean" },
        { name: "Prefix", param: "prefix" }
      ],
      orderMatch: {
        origin_asn_new: "Origin ASN New",
        origin_asn_old: "Origin ASN Old",
        time_5min: "Time",
        hijack_score_mean: "Hijack Score",
        impact_score_mean: "Impact Score",
        prefix: "Prefix"
      },
      allowExcludeSwitches: true,
      asn_own_dict: {},
      asn_get_owner: [],
      is_asn_owners: true,
      to_be_dealt: [],
      allow_dealt: false,
      show_popped: "",
      allow_popped: true,
      live_pulled: [],
      last_run_ts: null,
      user_alerts: [],
      user_recent_alerts: [],
      user_bonus_alerts: [],
      org_alerts: [],
      org_recent_alerts: [],
      org_bonus_alerts: [],
      polling: null,
      run_poll: false,
      polling_interval: 10,
      polling_interval_rules: [v => v >= 10 || "Min. 10s polling interval"],
      org_asns: {},
      org_asns_arr: [],
      org_prefixes: {},
      org_prefixes_arr: [],
      org_bonus_asns: {},
      org_bonus_asns_arr: [],
      org_bonus_prefixes: {},
      org_bonus_prefixes_arr: [],
      user_asns: {},
      user_asns_arr: [],
      user_prefixes: {},
      user_prefixes_arr: [],
      user_bonus_asns: {},
      user_bonus_asns_arr: [],
      user_bonus_prefixes: {},
      user_bonus_prefixes_arr: [],
      poll_color: "success",
      poll_msg: "Start Live Updates",
      hijack_danger_threshold: 50,
      user_summarised: null,
      org_summarised: null,
      user_summarised_str: null,
      org_summarised_str: null,
      checker_local: false,
      filtered_alerts: [],
      load_filtered: false,
      load_user: true,
      load_org: true,
      showalerts: false,
      filter_criteria: {
        user: "",
        prefix: "",
        asn: ""
      },
      newalertsbanner_org: true,
      newalerts_org: false,
      newalertsbanner_user: true,
      newalerts_user: false,
      alertsbannercolor_org: "blue",
      alertsbannercolor_user: "blue",
      newalertsmessage_org: "test",
      newalertsmessage_user: "test",
      adding_alerts: false,
      org_alerts_flip: true,
      user_alerts_flip: true,
      org_only: false,
      org_prefix_names: {},
      org_show_names: false,
      user_prefix_names: {},
      user_show_names: false,
      options: {
          onClick: this.chartHandle,
          passive: true,
          //aspectRatio: 0.2,
          maintainAspectRatio: false,
          layout: {
              padding: {
                left: 50,
                right: 50,
                top: 50,
                bottom: 50
              }
          },
          legend: {
              labels: {
                  // This more specific font property overrides the global property
                  fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
              }
          },
          tooltips: {
              bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
              callbacks: {
                  label: function(tooltipItem, data ) {
                      try {
                          var eventCount = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].ev_count
                          if (eventCount ==50) {
                              eventCount= "50+"
                          }
                          var comboScore = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                          var epochTime = tooltipItem.xLabel
                          var d_t = new Date( epochTime *1000);
                          var date = d_t.toLocaleString().substr(0, 10);
                          var time = d_t.toLocaleString().substr(11, 9);
                          var label = "Event Count: "+eventCount+", Hijack Score: " +comboScore+", Date: " +date + ", Time: " + time

                          return label
                          }
                          catch(err) {
                              console.log(err)
                      }
                  }
              }
          },
          responsive: true,
          
          scales: {
              yAxes: [{
                  scaleLabel: {
                      display: true,
                      labelString: 'Hijack Score (H)',
                      fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                  },
                  ticks: {
                      min: 0,
                      stepSize: 20,
                      max: 100,
                      fontSize: this.$store.state.textFormatting.chart.axis_label
                  }
              }],
              xAxes: [{
                  ticks: {
                      fontSize: this.$store.state.textFormatting.chart.axis_label,
                      callback: (value, index, values) => {
                          var dataPointEpochTimeInHRFormat = new Date (value *1000);
                          let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                          return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                      }
                  }
              }]
          },
          pan: {
              enabled: true,
              passive: true,
              mode: 'x'
          },
          zoom: {
              enabled: true,
              passive: true,
              mode: 'x',
          }
      },
      bubbleData: null,
      user_bubbledata: null,
      org_bubbledata: null,
      showbubble: false,
      bubble_type: null,
      countDown: 10,
      countDownSt: 10,
      countdownColor: 'success',
      allowCount: false,
      bubble_alert: false
    };
  },
  beforeMount() {
    let app = findParentComponentByName(this, "app");
    app.checkSignedIn();
    if (window.location.origin == "http://localhost:8081") {
      this.checker_local = true;
    }
  },
  mounted() {
    this.exclude_path_change = this.$store.state.alertsExcPath;
    this.exclude_first_seen = this.$store.state.alertsExcFirst;
    this.exclude_own_assert = this.$store.state.alertsExcOwnAssert;
    this.exclude_in_path = this.$store.state.alertsExcInPath;
    try {
        this.organisation = this.$store.state.user.organisation;
        this.user = this.$store.state.user.username;
        this.headers[6].text[0] = this.organisation
    } catch (err) {
        console.log(err)
        location.reload()
    }
    this.run_poll = false;
    this.allowCount = true;
    this.getControlledPrefixes();
    this.top10alerts("user");
    this.top10alerts("org");
    this.allowExcludeSwitches = true;

  },
  created() {
    const vm = this;
    clearInterval(vm.polling);
    //this.pollData();
    this.run_poll = false;
    this.allowCount = true;
    this.countdownTimer();
  },
  beforeDestroy() {
    clearInterval(this.polling);
    this.allowCount = false
  },
  methods: {
    chartHandle: async function (point, event) {
      //console.log(point)
      //console.log(event)
      if ( event.length > 0 ) {
        //console.log(event[0]._datasetIndex)
        //console.log(event[0]._index)
        //console.log(this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index])
        this.bubble_alert = [this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index].full_alert]
      }
    },
    getAlertType: function (alert) {
        /* if (alert.asn_of_interest == 'Restricted Prefix') {
            return 'Restricted Prefix'
        } else */
        if (alert.origin_asn_old == '0' || alert.origin_asn_old == 0) {
            return 'First Seen Prefix'
        } else if (alert.origin_asn_new == alert.origin_asn_old) {
            return 'Path Change'
        } else {
            if (alert.non_direct_prefix == 'N/A') {
                return 'Ownership Assertion'
            } else {
                var nd_cidr = parseInt(alert.non_direct_prefix.split("/")[1])
                var cidr = parseInt(alert.prefix.split("/")[1])
                if (nd_cidr > cidr) {
                    return 'Super-ownership Assertion'
                } else {
                    return 'Sub-ownership Assertion'
                }

            }
        }
    },
    countdownTimer: function () {
      if ( this.countDown > 0 && this.run_poll ) {
        setTimeout(() => {
          this.countDown -= 1
          this.preCountdownTimer()
        }, 1000)
      } else if ( this.run_poll ) {
        console.log("RUNNING ALERTS FROM COUNTDOWN")
        this.pullNewAlerts()
        this.countDown = this.countDownSt
        this.preCountdownTimer();
      } else {
        setTimeout(() => {
          this.preCountdownTimer()
        }, 1000)
      }
    },
    preCountdownTimer: function () {
      if (this.allowCount) {
        this.countdownTimer()
      }
    },
    bubbleExclude: async function () {
      this.user_bubbledata = this.createBubbleDatasets('user')
      this.org_bubbledata = this.createBubbleDatasets('org')
      if (this.bubble_type == 'org') {
        this.useBubbleData('org')
      } else {
        this.useBubbleData('user')
      }
    },
    useBubbleData: async function (usr) {
      if (usr == 'user') {
        this.showbubble = false
        this.bubble_alert = false
        this.bubble_type = 'user'
        this.bubbleData = this.user_bubbledata
        this.bubbleHeaders[5].text[0] = this.user
        this.showbubble = true
      } else {
        this.showbubble = false
        this.bubble_alert = false
        this.bubble_type = 'org'
        this.bubbleData = this.org_bubbledata
        this.bubbleHeaders[5].text[0] = this.organisation
        this.showbubble = true
      }
    },
    createBubbleDatasets: function(usr) {

        var uniqueASNs
        var uniquePrefs
        var alerts
        var current_keys

        if (usr == 'user') {
          uniqueASNs = Object.keys(this.user_asns)
          uniquePrefs = Object.keys(this.user_prefixes)
          alerts = this.user_alerts
          current_keys = {}
          try {
            for (var i = 0 ; i < this.user_bubbledata.datasets.length ; i++ ) {
              current_keys[this.user_bubbledata.datasets[i].label] = this.user_bubbledata.datasets[i].backgroundColor
            }
          } catch {
            current_keys = {}
          }
          
        } else {
          uniqueASNs = Object.keys(this.org_asns)
          uniquePrefs = Object.keys(this.org_prefixes)
          alerts = this.org_alerts
          current_keys = {}
          try {
            for (var i = 0 ; i < this.org_bubbledata.datasets.length ; i++ ) {
              current_keys[this.org_bubbledata.datasets[i].label] = this.org_bubbledata.datasets[i].backgroundColor
            }
          } catch {
            current_keys = {}
          }
        }

        //console.log(uniqueASNs)
        //console.log(uniquePrefs)
        //console.log(alerts)
        //console.log(current_keys)
        
        var bubbleData = {
            datasets: []
        }

        for (var i = 0; i < uniqueASNs.length; i++ ) {
          if (!(Object.keys(current_keys).includes(uniqueASNs[i]))) {
            var datasetFull = {
              label: uniqueASNs[i],
              data: [],
              backgroundColor: "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
            }
            bubbleData.datasets.push(datasetFull)
          } else {
            var datasetFull = {
              label: uniqueASNs[i],
              data: [],
              backgroundColor: current_keys[uniqueASNs[i]]
            }
            bubbleData.datasets.push(datasetFull)
          }
        }

        for (var i = 0; i < uniquePrefs.length; i++ ) {
          if (!(Object.keys(current_keys).includes(uniquePrefs[i]))) {
            var datasetFull = {
              label: uniquePrefs[i],
              data: [],
              backgroundColor: "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
            }
            bubbleData.datasets.push(datasetFull)
          } else {
            var datasetFull = {
              label: uniquePrefs[i],
              data: [],
              backgroundColor: current_keys[uniquePrefs[i]]
            }
            bubbleData.datasets.push(datasetFull)
          }
        }

        

        //console.log(bubbleData)

        for (var i=0 ; i < alerts.length; i++ ) {
            
            if (this.passCriteria(alerts[i])) {


              if (alerts[i].asn_of_interest == 'Restricted Prefix') {
                //console.log(alerts[i].controlled_prefix)
                var score_combo = alerts[i].hijack_score_mean
                if ( alerts[i].event_count > 50 ) {
                    var bubblesize = 50
                } else {
                    var bubblesize = Math.round(alerts[i].event_count * 45/50) + 5
                }
                var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                for(var j = 0; j < bubbleData.datasets.length ; j++ ) {
                  if (bubbleData.datasets[j].label == alerts[i].controlled_prefix) {
                    bubbleData.datasets[j].data.push(dataset)
                  }  
                }

              } else {
                //console.log(alerts[i].asn_of_interest)
                var score_combo = alerts[i].hijack_score_mean
                if ( alerts[i].event_count > 50 ) {
                    var bubblesize = 50
                } else {
                    var bubblesize = Math.round(alerts[i].event_count * 45/50) + 5
                }
                var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                for(var j = 0; j < bubbleData.datasets.length ; j++ ) {
                  if (bubbleData.datasets[j].label == alerts[i].asn_of_interest) {
                    bubbleData.datasets[j].data.push(dataset)
                  }  
                }
                
              }
            }            
            
        }
        return bubbleData
    },
    getControlledPrefixes: async function () {
      try {
        var prefsQuery = `query getControlledPrefixesQuery { getControlledPrefixes(
            organisation: "` + this.organisation +`"
        ) { 
            hostname
            ipv4_address
            ipv6_address
          } 
        }`;
        const prefData = await API.graphql(graphqlOperation(prefsQuery));
        var prefs = prefData.data.getControlledPrefixes;

        if (prefs.length == 0 || prefs === undefined) {
            this.org_prefix_names = {}
        } else {
            for (var i = 0; i < prefs.length ; i++) {
                if (prefs[i].ipv4_address == '') {
                    this.org_prefix_names[prefs[i].ipv6_address] = prefs[i].hostname
                } else {
                    this.org_prefix_names[prefs[i].ipv4_address] = prefs[i].hostname
                }   
            }
        }
      } catch(err) {
          console.log(err)
          console.log("An Error has occurred: " + err.errors[0].message)
      }

      try {
        var prefsQuery = `query getControlledPrefixesQuery { getControlledPrefixes(
            organisation: "` + this.organisation +`",
            p_user: "` + this.user + `"
        ) { 
            hostname
            ipv4_address
            ipv6_address
          } 
        }`;
        const prefData = await API.graphql(graphqlOperation(prefsQuery));
        var prefs = prefData.data.getControlledPrefixes;

        if (prefs.length == 0 || prefs === undefined) {
            this.user_prefix_names = {}
        } else {
            for (var i = 0; i < prefs.length ; i++) {
                if (prefs[i].ipv4_address == '') {
                    this.user_prefix_names[prefs[i].ipv6_address] = prefs[i].hostname
                } else {
                    this.user_prefix_names[prefs[i].ipv4_address] = prefs[i].hostname
                }   
            }
        }
      } catch(err) {
          console.log(err)
          console.log("An Error has occurred: " + err.errors[0].message)
      }
    },
    mergeAlerts: async function(usr) {
      if (!this.adding_alerts) {
        var alerts;
        var newalerts;
        this.adding_alerts = true;
        if (usr == "user") {
          newalerts = this.user_bonus_alerts;
          alerts = this.user_alerts;
        } else {
          newalerts = this.org_bonus_alerts;
          alerts = this.org_alerts;
        }
        //const pr_alerts = Array.from(newalerts)
        //console.log(pr_alerts)
        for (var i = 0; i < alerts.length; i++) {
          //console.log(i);
          if (i > 0) {
            break
          }
          if (newalerts != [] && newalerts[i]) {
            //console.log(newalerts[i].prefix);
            alerts.push(newalerts[i]);
            newalerts.splice(i, 1)
            i -= 1;
          }
        }
        //console.log(newalerts)
        if (newalerts.length == 0) {
          if (usr == 'user') {
            console.log("REDOING AGGREGATION (user)")
            this.newAlertsAgg(
              this.user_asns,
              this.user_prefixes,
              this.user_alerts
            );

            this.user_summarised = this.summariseASNDict(
              this.user_asns
            );
            this.user_asns_arr = this.asnDictToArr(
              this.user_summarised
            );
            //console.log(this.user_summarised)
            this.summarisePrefixDictToStr(this.user_prefixes);
            this.user_prefixes_arr = this.preDictToArr(
              this.user_prefixes
            );
            this.user_bubbledata = this.createBubbleDatasets('user')
            if (this.bubble_type == 'user') {
              this.useBubbleData('user')
            }
            this.user_bonus_alerts = []
            this.user_bonus_prefixes = {}
            this.user_bonus_prefixes_arr = []
            this.user_bonus_asns = {}
            this.user_bonus_asns_arr = []
          } else {
            console.log("REDOING AGGREGATION (org)")
            this.newAlertsAgg(
              this.org_asns,
              this.org_prefixes,
              this.org_alerts
            );

            this.org_summarised = this.summariseASNDict(
              this.org_asns
            );
            this.org_asns_arr = this.asnDictToArr(
              this.org_summarised
            );
            //console.log(this.org_summarised)
            this.summarisePrefixDictToStr(this.org_prefixes);
            this.org_prefixes_arr = this.preDictToArr(
              this.org_prefixes
            );
            this.org_bubbledata = this.createBubbleDatasets('org')
            if (this.bubble_type == 'org') {
              this.useBubbleData('org')
            }
            this.org_bonus_alerts = []
            this.org_bonus_prefixes = {}
            this.org_bonus_prefixes_arr = []
            this.org_bonus_asns = {}
            this.org_bonus_asns_arr = []
          }
        }
        this.adding_alerts = false
      } else {
        console.log("currently adding alerts already");
      }
    },
    showNewAlerts: async function(usr) {
      this.filterAlerts(usr, "", "");
    },
    passCriteria: function(alert) {
      if (!this.exclude_first_seen && alert.origin_asn_old == "0") {
        return false;
      }
      if (
        !this.exclude_path_change &&
        alert.origin_asn_old == alert.origin_asn_new
      ) {
        return false;
      }
      if (
        !this.exclude_own_assert &&
        alert.origin_asn_old != alert.origin_asn_new &&
        alert.origin_asn_old != "0"
      ) {
        return false;
      }
      if (
        (
          !this.exclude_in_path &&
          alert.origin_asn_old != alert.asn_of_interest &&
          alert.origin_asn_new != alert.asn_of_interest
        ) && (
          alert.asn_of_interest != 'Restricted Prefix'
        )
      ) {
        return false;
      }
      return true;
    },
    filterAlerts: async function(user, cont_prefix, asn) {
      var alerts;
      this.load_filtered = true;
      this.to_be_dealt = []
      this.allow_dealt = false

      console.log("filtering: prefix = " + cont_prefix + ", asn: " + asn);
      this.filtered_alerts = [];
      if (user == "user") {
        this.headers[6].text[0] = this.user
        alerts = this.user_alerts;
      } else if (user == "newuser") {
        this.headers[6].text[0] = this.user
        alerts = this.user_bonus_alerts;
      } else if (user == "neworg") {
        this.headers[6].text[0] = this.organisation
        alerts = this.org_bonus_alerts;
      } else {
        this.headers[6].text[0] = this.organisation
        alerts = this.org_alerts;
      }

      for (var i = 0; i < alerts.length; i++) {
        if (cont_prefix == "" && asn == "") {
          if (this.passCriteria(alerts[i])) {
            this.filtered_alerts.push(alerts[i]);
          }
        } else {
          if (cont_prefix == "") {
            //searching in ASN summary
            if (
              alerts[i].asn_of_interest == asn &&
              this.passCriteria(alerts[i])
            ) {
              this.filtered_alerts.push(alerts[i]);
            }
          } else {
            if (
              alerts[i].asn_of_interest == cont_prefix &&
              alerts[i].controlled_prefix == cont_prefix &&
              this.passCriteria(alerts[i])
            ) {
              this.filtered_alerts.push(alerts[i]);
            }
          }
        }
      }
      this.load_filtered = false;
      this.filter_criteria = {
        user: user,
        prefix: cont_prefix,
        asn: asn
      };
      this.showalerts = true;
    },
    changePollingInterval: async function() {
      clearInterval(this.polling);
      this.countDownSt = this.polling_interval;
      this.polling = null;
    },
    flipPoll: async function() {
      if (this.run_poll) {
        this.run_poll = false;
        this.poll_msg = "Start Live Updates";
        this.poll_color = "success";

      } else {
        this.run_poll = true;
        this.poll_msg = "Stop Live Updates";
        this.poll_color = "red";
      }
    },
    getColor: function(indate) {
      try {
        let d_obj = new Date();
        let day = ("0" + d_obj.getUTCDate()).slice(-2);
        let mon = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
        let yr = d_obj.getUTCFullYear();
        let fdate = day + "/" + mon + "/" + yr;

        d_obj.setDate(d_obj.getUTCDate() - 1);
        let day2 = ("0" + d_obj.getUTCDate()).slice(-2);
        let mon2 = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
        let yr2 = d_obj.getUTCFullYear();
        let yfdate = day2 + "/" + mon2 + "/" + yr2;

        if (fdate == indate) {
          return "#FF6347";
        } else if (yfdate == indate) {
          return "#FFDAB9";
        } else {
          return "#ffffff";
        }
      } catch (err) {
        console.log(err);
      }
    },
    summariseASNDict: function(dict) {
      var asns = Object.keys(dict); //asns
      var new_dict = {};
      for (var i = 0; i < asns.length; i++) {
        var asn = asns[i];
        var pre_dict = dict[asns[i]];
        var prefixes = Object.keys(pre_dict);
        var pre_counts = {
          potentially_hijacked: {
            count: 0,
            prefixes: []
          },
          announced_from: 0
        };

        // detect stuff
        for (var j = 0; j < prefixes.length; j++) {
          var this_prefix = pre_dict[prefixes[j]];
          if (this_prefix["from_this_asn"]["count"] > 0) {
            pre_counts["potentially_hijacked"]["count"] += 1;
            pre_counts["potentially_hijacked"]["prefixes"].push(prefixes[j]);
          } else if (
            this_prefix["to_this_asn"]["count"] > 0 ||
            this_prefix["path_change"]["count"] > 0
          ) {
            pre_counts["announced_from"] += 1;
          }
        }

        // construct the string
        if (pre_counts["potentially_hijacked"]["count"] > 0) {
          if (pre_counts["potentially_hijacked"]["count"] > 1) {
            var hij_str =
              pre_counts["potentially_hijacked"]["count"] +
              " prefixes potentially hijacked: " +
              pre_counts["potentially_hijacked"]["prefixes"].join(", ");
          } else {
            var hij_str =
              "1 prefix potentially hijacked: " +
              pre_counts["potentially_hijacked"]["prefixes"][0];
          }
        } else {
          var hij_str = "No prefixes (potentially) hijacked";
        }
        if (pre_counts["announced_from"] > 0) {
          if (pre_counts["announced_from"] > 1) {
            var ann_str =
              pre_counts["announced_from"] + " prefixes announced from this AS";
          } else {
            var ann_str = "1 prefix announced from this AS";
          }
        } else {
          var ann_str = "No prefixes announced from this AS";
        }

        new_dict[asn] = hij_str + ", " + ann_str;
      }
      return new_dict;
    },
    summarisePrefixDictToStr: function(dict) {
      var keys = Object.keys(dict);
      var asn_to;
      var asn_from;
      var spl;
      var return_str;
      var addstr;
      for (var i = 0; i < keys.length; i++) {
        return_str = "";
        var asn_directs = dict[keys[i]];
        var asn_direct_keys = Object.keys(asn_directs);
        var ok = [];
        var maybe_not_ok = [];
        //console.log(asn_direct_keys);
        for (var j = 0; j < asn_direct_keys.length; j++) {
          if (
            asn_direct_keys[j] == "str" ||
            asn_direct_keys[j] == "potential_hijacks"
          ) {
            continue;
          }
          spl = asn_direct_keys[j].split("->");
          asn_from = spl[0];
          asn_to = spl[1];
          if (
            asn_direct_keys.includes(asn_to + "->" + asn_from) ||
            asn_from == "0" ||
            asn_from == asn_to
          ) {
            if (asn_from == "0") {
              ok.push(asn_to);
            } else {
              ok.push(asn_to);
              ok.push(asn_from);
            }
          } else {
            maybe_not_ok.push(asn_direct_keys[j]);
          }
        }
        //console.log("OK");
        //console.log(ok);
        //console.log("MAYBE NOT OK");
        //console.log(maybe_not_ok);
        for (var j = 0; j < maybe_not_ok.length; j++) {
          spl = maybe_not_ok[j].split("->");
          //console.log("SPL");
          //console.log(spl);
          asn_from = spl[0];
          asn_to = spl[1];
          if (asn_from != asn_to) {
            addstr =
              "Potential hijack from " + asn_from + " to " + asn_to + "; ";
            return_str += addstr;
          } else {
            maybe_not_ok.splice(j, 1);
            j -= 1;
            continue;
          }
        }

        ok = [...new Set(ok)];
        if (ok.length == 1) {
          addstr = "Ownership from:";
        } else {
          addstr = "Ownership alternating between:";
        }

        for (var j = 0; j < ok.length; j++) {
          addstr += " AS ";
          addstr += ok[j];
          if (j != ok.length - 1) {
            addstr += ",";
          }
        }

        if (ok.length > 0) {
          return_str += addstr;
        }
        dict[keys[i]]["str"] = return_str;
        dict[keys[i]]["potential_hijacks"] =
          maybe_not_ok.length > 0 ? true : false;
      }
    },
    asnDictToArr: function(asn_dict) {
      var asns = Object.keys(asn_dict);
      var asn_arr = [];
      for (var i = 0; i < asns.length; i++) {
        asn_arr.push({
          asn: asns[i],
          summary: asn_dict[asns[i]],
          potential_hijacks: asn_dict[asns[i]].includes("(potentially)")
            ? false
            : true,
          color: asn_dict[asns[i]].includes("(potentially)") ? "success" : "red"
        });
      }
      return asn_arr;
    },
    preDictToArr: function(pre_dict) {
      var pres = Object.keys(pre_dict);
      var pre_arr = [];
      for (var i = 0; i < pres.length; i++) {
        pre_arr.push({
          prefix: pres[i],
          summary: pre_dict[pres[i]].str,
          potential_hijacks: pre_dict[pres[i]].potential_hijacks,
          color: pre_dict[pres[i]].potential_hijacks ? "red" : "success"
        });
      }
      return pre_arr;
    },
    changeOrderBy: function(order, type) {
      if (type == "user") {
        this.orderBy = order;
        this.pagination.sortBy = null;
        this.pagination.descending = null;
        this.top10Message =
          "My organisation's episodes ordered by " +
          this.orderMatch[this.orderBy];
        this.top10alerts("refresh", order);
      } else if (type == "global") {
        this.orderBy = order;
        this.pagination.sortBy = null;
        this.pagination.descending = null;
        this.top10Message =
          "Global episodes ordered by " + this.orderMatch[this.orderBy];
        this.top10alerts("refresh", order);
      }
    },
    pullNewAlerts: async function() {
      if (this.run_poll) {
        console.log("running poll for new alerts...");
        this.pullNewAlertsOrg();
        this.pullNewAlertsUser();
        var d = new Date();
        var day = ("0" + d.getUTCDate()).slice(-2);
        var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
        var year = d.getUTCFullYear()
        var dateFormatted = day + "/" + month + "/" + year
        var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
        this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted
      } else {
        console.log("not running poll (set not to run)");
      }
    },
    newAlertsAgg: function(insert_dict, insert_dict_2, alerts) {
      // dict 1 is ASNs, dict 2 is prefixes
      for (var i = 0; i < alerts.length; i++) {
        try {
          if (
            alerts[i].asn_of_interest.includes('/') &&
            !Object.keys(insert_dict_2).includes(alerts[i].controlled_prefix)
          ) {
            insert_dict_2[alerts[i].controlled_prefix] = {};
          } else if (
            !Object.keys(insert_dict).includes(alerts[i].asn_of_interest) &&
            !alerts[i].asn_of_interest.includes('/')
          ) {
            insert_dict[alerts[i].asn_of_interest] = {};
          }
          if (alerts[i].asn_of_interest.includes('/')) {
            if (
              !Object.keys(insert_dict_2[alerts[i].controlled_prefix]).includes(
                alerts[i].origin_asn_old + "->" + alerts[i].origin_asn_new
              )
            ) {
              insert_dict_2[alerts[i].controlled_prefix][
                (
                  alerts[i].origin_asn_old +
                  "->" +
                  alerts[i].origin_asn_new
                ).toString()
              ] = 0;
            }
            insert_dict_2[alerts[i].controlled_prefix][
              (
                alerts[i].origin_asn_old +
                "->" +
                alerts[i].origin_asn_new
              ).toString()
            ] += 1;
          } else {
            if (
              !Object.keys(insert_dict[alerts[i].asn_of_interest]).includes(
                alerts[i].prefix
              )
            ) {
              insert_dict[alerts[i].asn_of_interest][alerts[i].prefix] = {
                to_this_asn: { count: 0, mean_h: 0, "#_over_danger": 0 },
                from_this_asn: {
                  count: 0,
                  mean_h: 0,
                  "#_over_danger": 0,
                  hij_asns: []
                },
                path_change: { count: 0, mean_h: 0, "#_over_danger": 0 },
                in_path: { count: 0, mean_h: 0, "#_over_danger": 0 }
              };
            }
            // is of interest = new origin
            const n_s = alerts[i].origin_asn_new == alerts[i].asn_of_interest;
            // is of interest = old origin
            const o_s = alerts[i].origin_asn_old == alerts[i].asn_of_interest;
            let pre_dict =
              insert_dict[alerts[i].asn_of_interest][alerts[i].prefix];
            if (n_s || o_s) {
              if (n_s && o_s) {
                //path change
                pre_dict["path_change"] = {
                  count: pre_dict["path_change"]["count"] + 1,
                  mean_h:
                    (pre_dict["path_change"]["count"] *
                      pre_dict["path_change"]["mean_h"] +
                      alerts[i].hijack_score_mean) /
                    (pre_dict["path_change"]["count"] + 1),
                  "#_over_danger":
                    pre_dict["path_change"]["#_over_danger"] +
                    (alerts[i].hijack_score_mean >= this.hijack_danger_threshold
                      ? 1
                      : 0)
                };
              } else if (n_s) {
                pre_dict["to_this_asn"] = {
                  count: pre_dict["to_this_asn"]["count"] + 1,
                  mean_h:
                    (pre_dict["to_this_asn"]["count"] *
                      pre_dict["to_this_asn"]["mean_h"] +
                      alerts[i].hijack_score_mean) /
                    (pre_dict["to_this_asn"]["count"] + 1),
                  "#_over_danger":
                    pre_dict["to_this_asn"]["#_over_danger"] +
                    (alerts[i].hijack_score_mean >= this.hijack_danger_threshold
                      ? 1
                      : 0)
                };
              } else {
                pre_dict["from_this_asn"] = {
                  count: pre_dict["from_this_asn"]["count"] + 1,
                  mean_h:
                    (pre_dict["from_this_asn"]["count"] *
                      pre_dict["from_this_asn"]["mean_h"] +
                      alerts[i].hijack_score_mean) /
                    (pre_dict["from_this_asn"]["count"] + 1),
                  "#_over_danger":
                    pre_dict["from_this_asn"]["#_over_danger"] +
                    (alerts[i].hijack_score_mean >= this.hijack_danger_threshold
                      ? 1
                      : 0),
                  hij_asns: !pre_dict["from_this_asn"]["hij_asns"].includes(
                    alerts[i].origin_asn_new
                  )
                    ? pre_dict["from_this_asn"]["hij_asns"] +
                      [alerts[i].origin_asn_new]
                    : pre_dict["from_this_asn"]["hij_asns"]
                };
              }
            } else {
              pre_dict["in_path"] = {
                count: pre_dict["in_path"]["count"] + 1,
                mean_h:
                  (pre_dict["in_path"]["count"] *
                    pre_dict["in_path"]["mean_h"] +
                    alerts[i].hijack_score_mean) /
                  (pre_dict["in_path"]["count"] + 1),
                "#_over_danger":
                  pre_dict["in_path"]["#_over_danger"] +
                  (alerts[i].hijack_score_mean >= this.hijack_danger_threshold
                    ? 1
                    : 0)
              };
            }
          }
        } catch (err) {
          console.log(err);
          console.log(err.trace);
          console.log(alerts[i]);
          console.log(insert_dict);
          console.log(insert_dict_2);
        }
      }
    },
    pullNewAlertsOrg: async function() {
      let orgalerts = this.org_recent_alerts;
      var neworgalerts = await this.liveQueryPull("org");
      var latest_alert_ts = this.org_last_run_ts + 300;
      for (var i = 0; i < neworgalerts.length; i++) {
        var newalert = neworgalerts[i];
        var n = 1; //is it new or not
        if (newalert.time_5min > latest_alert_ts) {
          latest_alert_ts = newalert.time_5min;
        }

        if (newalert.asn_of_interest == "99999999999") {
          newalert.asn_of_interest = "Restricted Prefix";
        }
        if (newalert.non_direct_prefix == "null") {
          newalert.non_direct_prefix = "N/A";
        }

        newalert.alert_type = this.getAlertType(newalert)

        newalert.dealt_with_t = false;

        if (!this.asn_get_owner.includes(newalert.asn_of_interest.toString())) {
          this.asn_get_owner.push(newalert.asn_of_interest);
        }

        if (!this.asn_get_owner.includes(newalert.origin_asn_old.toString())) {
          this.asn_get_owner.push(newalert.origin_asn_old);
        }
        if (!this.asn_get_owner.includes(newalert.origin_asn_new.toString())) {
          this.asn_get_owner.push(newalert.origin_asn_new);
        }

        newalert.asn_of_interest = newalert.asn_of_interest.toString();

        var epochTime = newalert.interval_start;
        var dateTime = this.convertEpochtoTimeDate(epochTime);
        newalert.time_5min = epochTime;
        newalert.interval_start = dateTime;

        // we set the asn of interest to the restricted prefix for display purposes
        if (newalert.controlled_prefix != 'null' && newalert.asn_of_interest == 'Restricted Prefix') {
            newalert.asn_of_interest = newalert.controlled_prefix
        }

        for (var j = 0; j < orgalerts.length; j++) {
          var alert = orgalerts[j];

          if (
            alert["prefix"] == newalert["prefix"] &&
            alert["origin_asn_new"] == newalert["origin_asn_new"] &&
            alert["origin_asn_old"] == newalert["origin_asn_old"] &&
            alert["time_5min"] == newalert["time_5min"] &&
            alert["asn_of_interest"] == newalert["asn_of_interest"] &&
            alert["controlled_prefix"] == newalert["controlled_prefix"]
          ) {
            n = 0;
          }
          if (j == orgalerts.length - 1 && n == 1) {
            this.org_bonus_alerts.push(newalert);
            this.org_recent_alerts.push({
              prefix: newalert.prefix,
              origin_asn_new: newalert.origin_asn_new,
              origin_asn_old: newalert.origin_asn_old,
              time_5min: newalert.time_5min,
              asn_of_interest: newalert.asn_of_interest,
              controlled_prefix: newalert.controlled_prefix
            });
          }
        }
        if (i == neworgalerts.length - 1) {
          this.org_last_run_ts = latest_alert_ts - 300;
          this.newAlertsAgg(
            this.org_bonus_asns,
            this.org_bonus_prefixes,
            this.org_bonus_alerts
          );

          this.org_bonus_summarised = this.summariseASNDict(
            this.org_bonus_asns
          );
          this.org_bonus_asns_arr = this.asnDictToArr(
            this.org_bonus_summarised
          );
          //console.log(this.org_bonus_summarised)
          this.summarisePrefixDictToStr(this.org_bonus_prefixes);
          this.org_bonus_prefixes_arr = this.preDictToArr(
            this.org_bonus_prefixes
          );
        }
      }
      return 1;
    },
    pullNewAlertsUser: async function() {
      let useralerts = this.user_recent_alerts;
      var newuseralerts = await this.liveQueryPull("user");
      var latest_alert_ts = this.user_last_run_ts + 300;
      for (var i = 0; i < newuseralerts.length; i++) {
        var newalert = newuseralerts[i];
        var n = 1; //is it new or not
        if (newalert.time_5min > latest_alert_ts) {
          latest_alert_ts = newalert.time_5min;
        }
        if (newalert.asn_of_interest == "99999999999") {
          newalert.asn_of_interest = "Restricted Prefix";
        }
        if (newalert.non_direct_prefix == "null") {
          newalert.non_direct_prefix = "N/A";
        }

        newalert.alert_type = this.getAlertType(newalert)

        newalert.dealt_with_t = false;

        if (!this.asn_get_owner.includes(newalert.asn_of_interest.toString())) {
          this.asn_get_owner.push(newalert.asn_of_interest);
        }

        if (!this.asn_get_owner.includes(newalert.origin_asn_old.toString())) {
          this.asn_get_owner.push(newalert.origin_asn_old);
        }
        if (!this.asn_get_owner.includes(newalert.origin_asn_new.toString())) {
          this.asn_get_owner.push(newalert.origin_asn_new);
        }

        newalert.asn_of_interest = newalert.asn_of_interest.toString();

        var epochTime = newalert.interval_start;
        var dateTime = this.convertEpochtoTimeDate(epochTime);
        newalert.time_5min = epochTime;
        newalert.interval_start = dateTime;

        // we set the asn of interest to the restricted prefix for display purposes
        if (newalert.controlled_prefix != 'null' && newalert.asn_of_interest == 'Restricted Prefix') {
            newalert.asn_of_interest = newalert.controlled_prefix
        }

        for (var j = 0; j < useralerts.length; j++) {
          var alert = useralerts[j];
          if (
            alert["prefix"] == newalert["prefix"] &&
            alert["origin_asn_new"] == newalert["origin_asn_new"] &&
            alert["origin_asn_old"] == newalert["origin_asn_old"] &&
            alert["time_5min"] == newalert["time_5min"] &&
            alert["asn_of_interest"] == newalert["asn_of_interest"] &&
            alert["controlled_prefix"] == newalert["controlled_prefix"]
          ) {
            n = 0;
          }
          if (j == useralerts.length - 1 && n == 1) {
            this.user_bonus_alerts.push(newalert);
            this.user_recent_alerts.push({
              prefix: newalert.prefix,
              origin_asn_new: newalert.origin_asn_new,
              origin_asn_old: newalert.origin_asn_old,
              time_5min: newalert.time_5min,
              asn_of_interest: newalert.asn_of_interest,
              controlled_prefix: newalert.controlled_prefix
            });
          }
        }
        if (i == newuseralerts.length - 1) {
          this.user_last_run_ts = latest_alert_ts - 300;
          this.newAlertsAgg(
            this.user_bonus_asns,
            this.user_bonus_prefixes,
            this.user_bonus_alerts
          );

          this.user_bonus_summarised = this.summariseASNDict(
            this.user_bonus_asns
          );
          this.user_bonus_asns_arr = this.asnDictToArr(
            this.user_bonus_summarised
          );
          //console.log(this.user_bonus_summarised)
          this.summarisePrefixDictToStr(this.user_bonus_prefixes);
          this.user_bonus_prefixes_arr = this.preDictToArr(
            this.user_bonus_prefixes
          );
        }
      }
      return 1;
    },
    liveQueryPull: async function(u) {
      if (u == "user") {
        var usr = this.user;
        var ts = this.user_last_run_ts;
      } else {
        var usr = "whole_organisation";
        var ts = this.org_last_run_ts;
      }

      try {
        var query =
          `query getLiveNotificationsForOrg { getLiveNotificationsForOrg (
                        p_organisation: "` +
          this.organisation +
          `", 
                        p_user: "` +
          usr +
          `",
                        st_time: ` +
          ts +
          `
                    ) {
                        prefix
                        origin_asn_new
                        origin_asn_old
                        interval_start
                        hijack_score_min
                        impact_score_min
                        hijack_score_max
                        impact_score_max
                        hijack_score_mean
                        impact_score_mean
                        asn_of_interest
                        validation
                        event_count
                        countdown
                        email_count
                        organisation_name
                        notified_organisation
                        asn_class
                        dealt_with
                        user
                        controlled_prefix
                        non_direct_prefix
                    }  
                }`;
        console.log(query);
        const liveData = await API.graphql(graphqlOperation(query));
        console.log(liveData);
        var liveResults = liveData.data.getLiveNotificationsForOrg;
        console.log(liveResults);
        return liveResults;
      } catch (err) {
        console.log(err);
        return [];
      }
    },
    excludeChange: function() {
      this.filterAlerts(
        this.filter_criteria.user,
        this.filter_criteria.prefix,
        this.filter_criteria.asn
      );
    },
    getAllUserAlerts: async function(n) {
      try {
        this.showAllDownload = false;
        this.allUserAlerts = [];
        this.allLoading = true;
        this.allErrMsg = false;
        var query =
          `query top10 { getNotificationsForOrg (
                        page_offset: ` +
          n * 1000 +
          `, 
                        page_rows: ` +
          (n + 1) * 1000 +
          `, 
                        order_by:"` +
          this.orderBy +
          `",
                        exclude_path_change: ` +
          !this.exclude_path_change +
          `,
                        exclude_first_seen: ` +
          !this.exclude_first_seen +
          `,
                        exclude_in_path: ` +
          !this.exclude_in_path +
          `,
                        exclude_own_assert: ` +
          !this.exclude_own_assert +
          `
                    ) {
                        prefix
                        origin_asn_new
                        origin_asn_old
                        interval_start
                        hijack_score_min
                        impact_score_min
                        hijack_score_max
                        impact_score_max
                        hijack_score_mean
                        impact_score_mean
                        asn_of_interest
                        validation
                        event_count
                        countdown
                        controlled_prefix
                        email_count
                        organisation_name
                        notified_organisation
                        asn_class
                        dealt_with
                    }  
                }`;
        console.log(query);
        const allAlertsData = await API.graphql(graphqlOperation(query));
        console.log(allAlertsData);
        var allAlerts = allAlertsData.data.getNotificationsForOrg;
        console.log(allAlerts);
        if (allAlerts) {
          if (allAlerts.length > 0 && allAlerts[0].asn_class != null) {
            var urldata = window.location.origin + "/#/alertFromTop10/";

            for (var n = 0; n < allAlerts.length; n = n + 1) {
              if (allAlerts[n].asn_of_interest == "99999999999") {
                allAlerts[n].asn_of_interest = "Restricted Prefix";
              }

              allAlerts[n].alert_url =
                urldata +
                allAlerts[n].prefix.replace("/", "%2F") +
                "~" +
                allAlerts[n].origin_asn_old +
                "~" +
                allAlerts[n].origin_asn_new +
                "~" +
                allAlerts[n].interval_start;

              var epochTime = allAlerts[n].interval_start;
              var dateTime = this.convertEpochtoTimeDate(epochTime);
              allAlerts[n].time_5min = epochTime;
              allAlerts[n].interval_start = dateTime.date + dateTime.time;
            }
            this.allUserAlerts = allAlerts;
            this.allLoading = false;
            this.showAllDownload = true;
          } else {
            if (n > 0) {
              this.allErrMsg = "No additional alerts";
              this.allLoading = false;
              if (n == 1) {
                this.downloadStr = "1000 most recent alerts";
                this.allRound = 0;
              } else {
                this.allRound += -1;
                this.downloadStr =
                  "alerts " +
                  1000 * this.allRound +
                  " to " +
                  1000 * (this.allRound + 1);
              }
            } else {
              this.allErrMsg = "No alerts";
              this.allLoading = false;
            }
          }
          if (allAlerts.length > 999) {
            this.allRound += 1;
            this.oldDownStr = this.downloadStr;
            this.downloadStr =
              "alerts " +
              1000 * this.allRound +
              " to " +
              1000 * (this.allRound + 1);
          }
        } else {
          this.allUserAlerts = false;
          this.allErrMsg = "No alerts";
          this.allLoading = false;
        }
      } catch (err) {
        this.allUserAlerts = false;
        console.log(err);
        this.allErrMsg = "Error pulling all alerts";
        this.allLoading = false;
      }
    },
    getAnASNOwner: async function(asn) {
      if (asn == 0) {
        return "None";
      } else if (asn == "Restricted Prefix") {
        return "Restricted Prefix";
      } else {
        try {
          var qry =
            `query getASNOwner { getASNOwner ( asn: "` +
            asn +
            `" ) {
                            organisation
                        }
                    }`;
          //console.log(qry);
          const res = await API.graphql(graphqlOperation(qry));
          var ownData = res.data.getASNOwner;
          //console.log(ownData);
          if (ownData) {
            if (ownData.length > 0) {
              //console.log("owner: ");
              //console.log(ownData[0].organisation);
              if (ownData[0].organisation) {
                return ownData[0].organisation;
              } else {
                return "Unknown";
              }
            } else {
              return "Unknown";
            }
          } else {
            return "Unknown";
          }
        } catch (err) {
          console.log(err);
          return "Unknown";
        }
      }
    },
    getASNOwners: async function() {
      console.log("getting asn owners");
      for (var i = 0; i < this.asn_get_owner.length; i++) {
        var keys = Object.keys(this.asn_own_dict);
        if (!keys.includes(this.asn_get_owner[i].toString())) {
          this.asn_own_dict[this.asn_get_owner[i]] = await this.getAnASNOwner(
            this.asn_get_owner[i]
          );
        }
        if (i == this.asn_get_owner.length - 1) {
          this.is_asn_owners = false;
          this.$nextTick(() => {
            // Add the component back in
            this.is_asn_owners = true;
          });
        }
      }
    },
    tagDealtWith: async function(entry, tag) {
      entry.dealt_with = tag;
      var alerts
      if (this.filter_criteria.user == 'user') {
        alerts = this.user_alerts
      } else if (this.filter_criteria.user == 'org') {
        alerts = this.org_alerts
      } else if (this.filter_criteria.user == 'newuser') {
        alerts = this.user_bonus_alerts
      } else {
        alerts = this.org_bonus_alerts
      }
      //console.log(entry)
      //console.log(tag)
      //console.log(this.current10Data.indexOf(entry))
      if (tag == 1) {
        if (entry.asn_of_interest == "Restricted Prefix") {
          this.to_be_dealt.push({
            prefix: entry.prefix,
            origin_asn_new: entry.origin_asn_new,
            origin_asn_old: entry.origin_asn_old,
            time_5min: entry.time_5min,
            asn_of_interest: 99999999999,
            notified_organisation: entry.notified_organisation,
            user: entry.user,
            pos: alerts.indexOf(entry)
          });
        } else {
          this.to_be_dealt.push({
            prefix: entry.prefix,
            origin_asn_new: entry.origin_asn_new,
            origin_asn_old: entry.origin_asn_old,
            time_5min: entry.time_5min,
            asn_of_interest: entry.asn_of_interest,
            notified_organisation: entry.notified_organisation,
            user: entry.user,
            pos: alerts.indexOf(entry)
          });
        }
      } else {
        for (var i = 0; i < this.to_be_dealt.length; i++) {
          if (
            this.to_be_dealt[i].prefix == entry.prefix &&
            this.to_be_dealt[i].origin_asn_new == entry.origin_asn_new &&
            this.to_be_dealt[i].origin_asn_old == entry.origin_asn_old &&
            this.to_be_dealt[i].time_5min == entry.time_5min &&
            this.to_be_dealt[i].asn_of_interest == entry.asn_of_interest &&
            this.to_be_dealt[i].notified_organisation ==
              entry.notified_organisation &&
            this.to_be_dealt[i].user == entry.user
          ) {
            this.to_be_dealt.splice(i, 1);
            i -= 1;
          }
        }
      }
      if (this.to_be_dealt.length > 0) {
        this.allow_dealt = true;
      } else {
        this.allow_dealt = false;
      }
    },
    updateDealtWithMany: async function(dealt_w) {
      // (`prefix`, origin_asn_new, origin_asn_old, time_5min, asn_of_interest, organisation_name, `user`)
      var sendings = [];
      var to_go = [];
      if (this.show_popped != "") {
        dealt_w = 0;
      }

      var alerts
      if (this.filter_criteria.user == "user") {
        alerts = this.user_alerts
      } else if (this.filter_criteria.user == 'org') {
        alerts = this.org_alerts
      } else if (this.filter_criteria.user == 'newuser') {
        alerts = this.user_bonus_alerts
      } else {
        alerts = this.org_bonus_alerts
      }

      for (var i = 0; i < this.to_be_dealt.length; i++) {
        var entry = this.to_be_dealt[i];
        sendings.push(
          String.raw`(\"` +
            entry.prefix +
            String.raw`\",` +
            entry.origin_asn_new +
            `,` +
            entry.origin_asn_old +
            `,` +
            entry.time_5min +
            `,` +
            entry.asn_of_interest +
            `,` +
            String.raw`\"` +
            entry.notified_organisation +
            String.raw`\",\"` +
            entry.user +
            String.raw`\")`
        );
        to_go.push(entry.pos);
      }
      var sendstr = sendings.join(",");
      try {
        var query =
          `query getUpdateDealtWithMany { 
                    getUpdateDealtWithMany (
                        update_str: "` +
          sendstr +
          `", 
                        p_dealt_with: ` +
          dealt_w +
          `
                    )
                    {
                        ts
                    }  
                }`;
        console.log(query);
        const updata = await API.graphql(graphqlOperation(query));
        //console.log(updata)
        var updated = updata.data.getUpdateDealtWithMany;
        if (parseInt(updated[0].ts) == 1) {
          console.log("updated successfully");
        }
      } catch (err) {
        console.log(err);
      }
      to_go.sort();
      //console.log(to_go)
      for (var i = this.to_be_dealt.length - 1; i > -1; i--) {
        //console.log(to_go[i])
        alerts.splice(to_go[i], 1);
      }
      this.to_be_dealt = [];
      this.allow_dealt = false;
      this.filterAlerts(
        this.filter_criteria.user,
        this.filter_criteria.prefix,
        this.filter_criteria.asn
      );
    },
    showPoppedAlerts: async function() {
      this.show_popped = ", p_dealt_with: 1 ";
      this.allow_popped = false;
      this.top10alerts();
    },
    showUnpoppedAlerts: async function() {
      this.show_popped = "";
      this.allow_popped = true;
      this.top10alerts();
    },
    top10alerts: async function(u, order) {
      if (order == null) {
        order = "hijack_score_mean";
      }
      this.loading = true;
      this.current10Data = [];
      this.to_be_dealt = [];
      this.allow_dealt = false;
      if (u == "user") {
        var usr = this.user;
      } else {
        var usr = "whole_organisation";
      }
      try {
        var query =
          `query top10 { getNotificationsForOrg (
                        page_offset: 0, 
                        page_rows: 2000, 
                        order_by:"` +
          order +
          `",
                        exclude_path_change: false,
                        exclude_first_seen: false,
                        exclude_in_path: false,
                        p_user: "` +
          usr +
          `" 
                        exclude_own_assert: false ` +
          this.show_popped +
          `
                    ) {
                        prefix
                        origin_asn_new
                        origin_asn_old
                        interval_start
                        hijack_score_min
                        impact_score_min
                        hijack_score_max
                        impact_score_max
                        hijack_score_mean
                        impact_score_mean
                        asn_of_interest
                        validation
                        event_count
                        countdown
                        email_count
                        controlled_prefix
                        organisation_name
                        notified_organisation
                        asn_class
                        dealt_with
                        user
                        non_direct_prefix
                    }  
                }`;
        console.log(query);
        const top10data = await API.graphql(graphqlOperation(query));
        console.log(top10data);
        var t10 = top10data.data.getNotificationsForOrg;
        console.log(t10);
        var latest_alert_ts = 0;
        const time_delay = 600; //2 days

        for (var n = 0; n < t10.length; n = n + 1) {
          if (t10[n].interval_start > latest_alert_ts) {
            latest_alert_ts = t10[n].interval_start;
          }
          if (n == t10.length - 1) {
            if (u == "user") {
              this.user_last_run_ts = latest_alert_ts - time_delay;
            } else {
              this.org_last_run_ts = latest_alert_ts - time_delay;
            }
          }
        }

        for (var n = 0; n < t10.length; n = n + 1) {

          try {
            t10[n].asn_of_interest = t10[n].asn_of_interest.toString();
          } catch (err) {
            console.log(t10[n])
          }
          

          // for local testing, we remove the newest events, to pull them in with the live pull
          /*
          if (this.checker_local) {
            if (t10[n].interval_start >= latest_alert_ts - time_delay || t10[n].asn_of_interest == "5") {
              t10.splice(n, 1);
              n -= 1;
              continue;
            }
          }
          */

          if (t10[n].non_direct_prefix == "null") {
            t10[n].non_direct_prefix = "N/A";
          }

          if (t10[n].asn_of_interest == "99999999999") {
            t10[n].asn_of_interest = "Restricted Prefix";
          }

          t10[n].alert_type = this.getAlertType(t10[n])

          t10[n].dealt_with_t = false;

          if (!this.asn_get_owner.includes(t10[n].asn_of_interest.toString())) {
            this.asn_get_owner.push(t10[n].asn_of_interest);
          }

          if (!this.asn_get_owner.includes(t10[n].origin_asn_old.toString())) {
            this.asn_get_owner.push(t10[n].origin_asn_old);
          }
          if (!this.asn_get_owner.includes(t10[n].origin_asn_new.toString())) {
            this.asn_get_owner.push(t10[n].origin_asn_new);
          }

          t10[n].asn_of_interest = t10[n].asn_of_interest.toString();

          var epochTime = t10[n].interval_start;
          var dateTime = this.convertEpochtoTimeDate(epochTime);
          t10[n].time_5min = epochTime;
          t10[n].interval_start = dateTime;
          if (t10[n].interval_start >= latest_alert_ts) {
            if (u == "user") {
              this.user_recent_alerts.push({
                prefix: t10[n].prefix,
                origin_asn_new: t10[n].origin_asn_new,
                origin_asn_old: t10[n].origin_asn_old,
                time_5min: t10[n].time_5min,
                asn_of_interest: t10[n].asn_of_interest,
                controlled_prefix: t10[n].controlled_prefix
              });
            } else {
              this.org_recent_alerts.push({
                prefix: t10[n].prefix,
                origin_asn_new: t10[n].origin_asn_new,
                origin_asn_old: t10[n].origin_asn_old,
                time_5min: t10[n].time_5min,
                asn_of_interest: t10[n].asn_of_interest,
                controlled_prefix: t10[n].controlled_prefix
              });
            }
          }
          if (u == "user") {
            if (
              t10[n].asn_of_interest == "Restricted Prefix" &&
              !Object.keys(this.user_prefixes).includes(
                t10[n].controlled_prefix
              )
            ) {
              this.user_prefixes[t10[n].controlled_prefix] = {};
            } else if (
              !Object.keys(this.user_asns).includes(t10[n].asn_of_interest) &&
              t10[n].asn_of_interest != "Restricted Prefix"
            ) {
              this.user_asns[t10[n].asn_of_interest] = {};
            }
            if (t10[n].asn_of_interest == "Restricted Prefix") {
              if (
                !Object.keys(
                  this.user_prefixes[t10[n].controlled_prefix]
                ).includes(t10[n].origin_asn_old + "->" + t10[n].origin_asn_new)
              ) {
                this.user_prefixes[t10[n].controlled_prefix][
                  (
                    t10[n].origin_asn_old +
                    "->" +
                    t10[n].origin_asn_new
                  ).toString()
                ] = 0;
              }
              this.user_prefixes[t10[n].controlled_prefix][
                (
                  t10[n].origin_asn_old +
                  "->" +
                  t10[n].origin_asn_new
                ).toString()
              ] += 1;
            } else {
              if (
                !Object.keys(this.user_asns[t10[n].asn_of_interest]).includes(
                  t10[n].prefix
                )
              ) {
                this.user_asns[t10[n].asn_of_interest][t10[n].prefix] = {
                  to_this_asn: { count: 0, mean_h: 0, "#_over_danger": 0 },
                  from_this_asn: {
                    count: 0,
                    mean_h: 0,
                    "#_over_danger": 0,
                    hij_asns: []
                  },
                  path_change: { count: 0, mean_h: 0, "#_over_danger": 0 },
                  in_path: { count: 0, mean_h: 0, "#_over_danger": 0 }
                };
              }
              // is of interest = new origin
              const n_s = t10[n].origin_asn_new == t10[n].asn_of_interest;
              // is of interest = old origin
              const o_s = t10[n].origin_asn_old == t10[n].asn_of_interest;
              let pre_dict = this.user_asns[t10[n].asn_of_interest][
                t10[n].prefix
              ];
              if (n_s || o_s) {
                if (n_s && o_s) {
                  //path change
                  pre_dict["path_change"] = {
                    count: pre_dict["path_change"]["count"] + 1,
                    mean_h:
                      (pre_dict["path_change"]["count"] *
                        pre_dict["path_change"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["path_change"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["path_change"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0)
                  };
                } else if (n_s) {
                  pre_dict["to_this_asn"] = {
                    count: pre_dict["to_this_asn"]["count"] + 1,
                    mean_h:
                      (pre_dict["to_this_asn"]["count"] *
                        pre_dict["to_this_asn"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["to_this_asn"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["to_this_asn"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0)
                  };
                } else {
                  pre_dict["from_this_asn"] = {
                    count: pre_dict["from_this_asn"]["count"] + 1,
                    mean_h:
                      (pre_dict["from_this_asn"]["count"] *
                        pre_dict["from_this_asn"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["from_this_asn"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["from_this_asn"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0),
                    hij_asns: !pre_dict["from_this_asn"]["hij_asns"].includes(
                      t10[n].origin_asn_new
                    )
                      ? pre_dict["from_this_asn"]["hij_asns"] +
                        [t10[n].origin_asn_new]
                      : pre_dict["from_this_asn"]["hij_asns"]
                  };
                }
              } else {
                pre_dict["in_path"] = {
                  count: pre_dict["in_path"]["count"] + 1,
                  mean_h:
                    (pre_dict["in_path"]["count"] *
                      pre_dict["in_path"]["mean_h"] +
                      t10[n].hijack_score_mean) /
                    (pre_dict["in_path"]["count"] + 1),
                  "#_over_danger":
                    pre_dict["in_path"]["#_over_danger"] +
                    (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                      ? 1
                      : 0)
                };
              }
            }
          } else {
            if (
              t10[n].asn_of_interest == "Restricted Prefix" &&
              !Object.keys(this.org_prefixes).includes(t10[n].controlled_prefix)
            ) {
              this.org_prefixes[t10[n].controlled_prefix] = {};
            } else if (
              !Object.keys(this.org_asns).includes(t10[n].asn_of_interest) &&
              t10[n].asn_of_interest != "Restricted Prefix"
            ) {
              this.org_asns[t10[n].asn_of_interest] = {};
            }
            if (t10[n].asn_of_interest == "Restricted Prefix") {
              //console.log(this.org_prefixes)
              if (
                !Object.keys(
                  this.org_prefixes[t10[n].controlled_prefix]
                ).includes(t10[n].origin_asn_old + "->" + t10[n].origin_asn_new)
              ) {
                this.org_prefixes[t10[n].controlled_prefix][
                  t10[n].origin_asn_old + "->" + t10[n].origin_asn_new
                ] = 1;
              } else {
                this.org_prefixes[t10[n].controlled_prefix][
                  t10[n].origin_asn_old + "->" + t10[n].origin_asn_new
                ] += 1;
              }
              //console.log(this.org_prefixes)
            } else {
              if (
                !Object.keys(this.org_asns[t10[n].asn_of_interest]).includes(
                  t10[n].prefix
                )
              ) {
                this.org_asns[t10[n].asn_of_interest][t10[n].prefix] = {
                  to_this_asn: { count: 0, mean_h: 0, "#_over_danger": 0 },
                  from_this_asn: {
                    count: 0,
                    mean_h: 0,
                    "#_over_danger": 0,
                    hij_asns: []
                  },
                  path_change: { count: 0, mean_h: 0, "#_over_danger": 0 },
                  in_path: { count: 0, mean_h: 0, "#_over_danger": 0 }
                };
              }
              // is of interest = new origin
              const n_s = t10[n].origin_asn_new == t10[n].asn_of_interest;
              // is of interest = old origin
              const o_s = t10[n].origin_asn_old == t10[n].asn_of_interest;
              let pre_dict = this.org_asns[t10[n].asn_of_interest][
                t10[n].prefix
              ];
              if (n_s || o_s) {
                if (n_s && o_s) {
                  //path change
                  pre_dict["path_change"] = {
                    count: pre_dict["path_change"]["count"] + 1,
                    mean_h:
                      (pre_dict["path_change"]["count"] *
                        pre_dict["path_change"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["path_change"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["path_change"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0)
                  };
                } else if (n_s) {
                  pre_dict["to_this_asn"] = {
                    count: pre_dict["to_this_asn"]["count"] + 1,
                    mean_h:
                      (pre_dict["to_this_asn"]["count"] *
                        pre_dict["to_this_asn"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["to_this_asn"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["to_this_asn"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0)
                  };
                } else {
                  pre_dict["from_this_asn"] = {
                    count: pre_dict["from_this_asn"]["count"] + 1,
                    mean_h:
                      (pre_dict["from_this_asn"]["count"] *
                        pre_dict["from_this_asn"]["mean_h"] +
                        t10[n].hijack_score_mean) /
                      (pre_dict["from_this_asn"]["count"] + 1),
                    "#_over_danger":
                      pre_dict["from_this_asn"]["#_over_danger"] +
                      (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                        ? 1
                        : 0),
                    hij_asns: !pre_dict["from_this_asn"]["hij_asns"].includes(
                      t10[n].origin_asn_new
                    )
                      ? pre_dict["from_this_asn"]["hij_asns"] +
                        [t10[n].origin_asn_new]
                      : pre_dict["from_this_asn"]["hij_asns"]
                  };
                }
              } else {
                pre_dict["in_path"] = {
                  count: pre_dict["in_path"]["count"] + 1,
                  mean_h:
                    (pre_dict["in_path"]["count"] *
                      pre_dict["in_path"]["mean_h"] +
                      t10[n].hijack_score_mean) /
                    (pre_dict["in_path"]["count"] + 1),
                  "#_over_danger":
                    pre_dict["in_path"]["#_over_danger"] +
                    (t10[n].hijack_score_mean >= this.hijack_danger_threshold
                      ? 1
                      : 0)
                };
              }
            }
          }
          // we set the asn of interest to the restricted prefix for display purposes
          if (t10[n].controlled_prefix != 'null' && t10[n].asn_of_interest == 'Restricted Prefix') {
              t10[n].asn_of_interest = t10[n].controlled_prefix
          }
          if (n == t10.length - 1) {
            this.getASNOwners();
          }
        }
        var d = new Date();
        var day = ("0" + d.getUTCDate()).slice(-2);
        var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
        var year = d.getUTCFullYear()
        var dateFormatted = day + "/" + month + "/" + year
        var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
        this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted

        this.id = this.id + 1;
        if (u == "user") {
          this.user_alerts = t10;
          this.load_user = false;
          console.log("USER ASNS");
          this.user_summarised = this.summariseASNDict(this.user_asns);
          this.user_asns_arr = this.asnDictToArr(this.user_summarised);
          console.log(this.user_summarised);
          this.summarisePrefixDictToStr(this.user_prefixes);
          this.user_prefixes_arr = this.preDictToArr(this.user_prefixes);
          this.user_bubbledata = this.createBubbleDatasets('user')
        } else {
          this.org_alerts = t10;
          this.load_org = false;
          console.log("ORG ASNS");
          this.org_summarised = this.summariseASNDict(this.org_asns);
          this.org_asns_arr = this.asnDictToArr(this.org_summarised);
          console.log(this.org_summarised);
          this.summarisePrefixDictToStr(this.org_prefixes);
          this.org_prefixes_arr = this.preDictToArr(this.org_prefixes);
          this.org_bubbledata = this.createBubbleDatasets('org')
        }
      } catch (err) {
        if (u == "user") {
          this.user_alerts = [];
          this.load_user = false;
        } else {
          this.org_alerts = [];
          this.load_org = false;
        }
        console.log(err);
        var d = new Date();
        var day = ("0" + d.getUTCDate()).slice(-2);
        var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
        var year = d.getUTCFullYear()
        var dateFormatted = day + "/" + month + "/" + year
        var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
        this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted
      }
    },
    clickHandleAlert: async function(selectedAlertFromTable) {
      var paramatersCombined =
        selectedAlertFromTable.prefix +
        "~" +
        selectedAlertFromTable.origin_asn_old +
        "~" +
        selectedAlertFromTable.origin_asn_new +
        "~" +
        selectedAlertFromTable.time_5min;
      let routeData = this.$router.resolve({
        name: "Alert From Top 10",
        params: { prefix: paramatersCombined }
      });
      window.open(routeData.href, "_blank");
    },
    isEmpty: function(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    convertEpochtoTimeDate: function(epochTime) {
      try {
        var d_t = new Date(epochTime * 1000);

        var date = d_t.toLocaleString().substr(0, 10);
        var time = d_t.toLocaleString().substr(11, 9);

        var dateTime = { date: date, time: time };

        return dateTime;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    exclude_first_seen(n) {
      if (this.allowExcludeSwitches) {
        this.$store.commit("setAlertsExcFirst", n);
      }
      //console.log("changing first seen")
      //console.log(this.$store.state.alertsExcFirst)
    },
    exclude_path_change(n) {
      if (this.allowExcludeSwitches) {
        this.$store.commit("setAlertsExcPath", n);
      }
      //console.log("changing path change")
      //console.log(this.$store.state.alertsExcPath)
    },
    exclude_in_path(n) {
      if (this.allowExcludeSwitches) {
        this.$store.commit("setAlertsExcInPath", n);
      }
      //console.log("changing in path")
      //console.log(this.$store.state.alertsExcInPath)
    },
    exclude_own_assert(n) {
      if (this.allowExcludeSwitches) {
        this.$store.commit("setAlertsExcOwnAssert", n);
      }
      //console.log("changing in path")
      //console.log(this.$store.state.alertsExcInPath)
    }
  }
};
</script>

<style scoped>
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    table.v-table tbody td:first-child,
    table.v-table tbody td:not(:first-child),
    table.v-table tbody th:first-child,
    table.v-table tbody th:not(:first-child),
    table.v-table thead td:first-child,
    table.v-table thead td:not(:first-child),
    table.v-table thead th:first-child,
    table.v-table thead th:not(:first-child) {
      padding: 0 5px;
    }

    table.v-table tbody td,
    table.v-table tbody th {
      height: 38px;
    }

    switch.v-label {
      font-size: var(--label-size);
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }
</style>